<template>
  <div class="media align-items-center mb-3 d-flex">
    <app-avatar v-if="img" :src="img" alt="" :size="avatarSize" :circle="imgCircle" />
    <p class="ml-3 my-auto mr-2" v-if="title">{{ title }}</p>
    <div class="ml-auto mr-0 map-panel-first-row__meta">
      <div class="text-muted mb-1" v-if="id">ID: {{ id }}</div>
      <b-btn variant="secondary" size="sm" @click="edit" v-if="hasEdit">Edit</b-btn>
    </div>
  </div>
</template>

<script>
import AppAvatar from '@/components/shared/AppAvatar.vue'

export default {
  name: 'AppMapPointPanelFirstRow',
  components: { AppAvatar },
  props: {
    title: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    imgCircle: {
      type: Boolean,
      default: true
    },
    id: {
      type: [Number, String],
      default: ''
    },
    hasEdit: {
      type: Boolean,
      default: false
    },
    avatarSize: {
      type: String,
      default: '48px'
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style scoped>
.map-panel-first-row__meta > * {
  white-space: nowrap;
}
</style>
